<template>
    <div class="row">
        <div class="col-md-12 col-xl-12 col-xm-12">
            <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
                <Form ref="redeForm" @submit="payer" :validation-schema="paiementSchema">
                    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
                        <h5 class="card-title fw-bold mb-15 mb-lg-20 mb-xl-25"></h5>
                        <div class="border p-2 p-lg-4 border-dark border-opacity-10">
                            <div class="row">
                                <div class="col-md-4 col-sm-12">
                                    <div class="form-group">
                                        <label class="d-block text-black fw-semibold mb-10">
                                            Date Paiement <span class="text-danger">*</span>
                                        </label>
                                        <Field name="datePaiement" type="date" v-model="dateActuelle"
                                            class="form-control shadow-none fs-md-15 text-black" />
                                        <ErrorMessage name="datePaiement" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-8  col-sm-12">
                                    <div class="form-group">
                                        <label for="usager" class="form-label fw-medium text-black">
                                            Usager <span class="text-danger">*</span>
                                        </label>
                                        <Field name="usager" v-model="usager" type="text"
                                            class="form-control shadow-none fs-md-15 text-black" />
                                        <ErrorMessage name="usager" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12 col-xm-12 col-lg-6 col-xl-6">
                                    <div class="form-group">
                                        <label class="form-label fw-medium text-black">
                                            Type de recette <span class="text-danger">*</span>
                                        </label>
                                        <Field name="typeRecette" v-slot="{ field }" v-model="typeRecette">
                                            <Multiselect :options="typeOptions" :searchable="true" v-model="field.value"
                                                v-bind="field" placeholder="Sélectionner un type de recette" />
                                        </Field>
                                        <ErrorMessage name="typeRecette" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12 col-xm-12 col-lg-6 col-xl-6">
                                    <label for="contrat" class="form-label fw-medium text-black">
                                        Usager & Place
                                        <span class="text-danger">*</span>
                                    </label>
                                    <Field name="contrat" v-model="contrat"
                                        class="form-control shadow-none fs-md-15 text-black" v-slot="{ field }">
                                        <Multiselect v-model="field.value" v-bind="field" :filter-results="false"
                                            :min-chars="2" :resolve-on-load="false" :delay="0" :searchable="true"
                                            :options-limit="300" :options="async (query) => {
                                                if (query.length >= 3) {
                                                    const results = await reupererContrat(query);
                                                    if (results && results.length > 0) {
                                                        return results;
                                                    } else {
                                                        return [
                                                            { value: '', label: 'Aucun enregistrement trouvé' },
                                                        ];
                                                    }
                                                } else {
                                                    return [];
                                                }
                                            }
                                                " noOptionsText="Tapez au moins deux caractères"
                                            placeholder="Rechercher un contrat" />
                                    </Field>
                                    <ErrorMessage name="contrat" class="text-danger" />
                                </div>

                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group">
                                        <label for="mois" class="form-label fw-medium text-black">
                                            Motif de paiement <span class="text-danger">*</span>
                                        </label>
                                        <Field name="motif" v-model="intitule" type="text"
                                            class="form-control shadow-none fs-md-15 text-black" />
                                        <ErrorMessage name="motif" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-4 col-xm-12 col-sm-12">
                                    <div class="form-group">
                                        <label class="form-label fw-medium text-black">
                                            Taux <span class="text-danger">*</span>
                                        </label>
                                        <Field name="taux" v-model="taux" type="text"
                                            class="form-control shadow-none fs-md-15 text-black" />
                                        <ErrorMessage name="taux" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-12">
                                    <div class="form-group">
                                        <label class="form-label fw-medium text-black">
                                            Fréquence/Unité <span class="text-danger">*</span>
                                        </label>
                                        <Field name="frequence" v-slot="{ field }" v-model="frequence">
                                            <Multiselect :options="periodiciteOptions" :searchable="true"
                                                v-model="field.value" v-bind="field"
                                                placeholder="Sélectionner une fréquence de paiement" />
                                        </Field>
                                        <ErrorMessage name="frequence" class="text-danger" />
                                    </div>
                                </div>

                                <div class="col-md-4 col-sm-12">
                                    <div class="form-group">
                                        <label for="duree" class="form-label fw-medium text-black">
                                            Durée/Quantité <span class="text-danger">*</span>
                                        </label>
                                        <Field name="duree" v-model="duree"
                                            class="form-control shadow-none fs-md-15 text-black" />
                                        <ErrorMessage name="duree" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12 col-xm-12 col-lg-6 col-xl-6">
                                    <div class="form-group">
                                        <label class="form-label fw-medium text-black">
                                            Mode de paiement <span class="text-danger">*</span>
                                        </label>
                                        <Field name="mode" v-slot="{ field }" v-model="mode">
                                            <Multiselect :options="modes" :searchable="true" v-model="field.value"
                                                v-bind="field" placeholder="Sélectionner un mode" />
                                        </Field>
                                        <ErrorMessage name="mode" class="text-danger" />
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-12 col-xm-12 col-lg-6 col-xl-6" v-if="showTransactionIdField">
                                    <div class="form-group">
                                        <label class="form-label fw-medium text-black">
                                            Référence externe
                                            <span class="text-danger">*</span>
                                        </label>
                                        <Field type="text" name="transactionId" v-model="transactionId"
                                            class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer l'ID de transaction" />
                                        <ErrorMessage name="transactionId" class="text-danger" />
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-12 col-xm-12 col-lg-6 col-xl-6">
                                    <div class="form-group">
                                        <label for="montant" class="form-label fw-medium text-black">
                                            Montant
                                        </label>
                                        <Field name="montant" v-model="montant" :disabled="true"
                                            class="form-control shadow-none fs-md-15 text-black" />
                                        <ErrorMessage name="montant" class="text-danger" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer p-15 p-sm-20 p-md-25 p-lg-30 bg-white text-end">
                        <button v-show="valideEtape1"
                            class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                            type="submit">
                            Payer
                        </button>
                        <button
                            class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                            type="button" v-show="!valideEtape1" disabled>
                            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            <span class="visually-hidden">Chargement...</span>
                        </button>
                        <router-link to="/liste-paiement" class="btn btn-danger transition border-0 lh-1 fw-medium"><i
                                class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                            <span class="position-relative"></span>Annuler
                        </router-link>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, reactive, toRef, onMounted, computed } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import {
    error,
    success,
    format_date,
    telechargerFichier2,
    getUrlApiForFiles,
} from "@/utils/utils";
import { useRouter } from "vue-router";
import ApiService from "@/services/ApiService";
import JwtService from "@/services/JwtService";
import * as Yup from "yup";
import Multiselect from "@vueform/multiselect";
import axios from "axios";
import {
    openKkiapayWidget,
    addKkiapayListener,
    removeKkiapayListener,
} from "kkiapay";
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import { KKIAPAY } from "@/models/KKIAPAY";
import router from "@/router";
import { dateActuelle } from '@/utils/utils';

export default defineComponent({
    name: "PaiementAutreRecettes",
    components: {
        Form,
        Field,
        ErrorMessage,
        Multiselect,
    },
    setup(props, { emit }) {
        const paiementSchema = Yup.object().shape({
            typeRecette: Yup.number().notRequired(),
            contrat: Yup.number().notRequired(),
            usager: Yup.string().required("L'usager est obligatoire"),
            frequence: Yup.string().required("Séléctionnez au moins une fréquence de paiement"),
            motif: Yup.string().required("Le motif du paiement est obligatoire").default("Paiement de recette"),
            taux: Yup.number().required("Le taux est obligatoire").positive().integer().min(100, "Le taux minimal est de 100 F CFA").default(0),
            montant: Yup.number().required("Le montant est obligatoire").positive().min(100, "Le montant minimal est de 100 F CFA").default(0),
            mode: Yup.number().required("Sélectionnez un mode de paiement"),
            datePaiement: Yup.string().required("La date de paiement est obligatoire"),
            duree: Yup.number().required("La durée est obligatoire").positive().integer().min(1, "Le nombre de mois minimal est 1").default(1),
            transactionId: Yup.string()
                .nullable()
                .test("transactionId-required", "La référence externe du paiement est obligatoire", function (value) {
                    const mode = this.parent.mode;
                    if (mode !== 1 && mode !== 2 && mode !== 0) {
                        return value !== null && value !== undefined && value.trim() !== "";
                    }
                    return true;
                }),
        });

        const typeRecette = ref();
        const dateDebut = ref(null);
        const agent = ref();
        const valideEtape1 = ref(true);
        const taux = ref(0);
        const mode = ref(null);
        const modes = ref([]);
        const montant = ref(0);
        const usager = ref('');
        const contrat = ref(null);
        const contrats = ref<Array<any>>([]);
        const transactionId = ref("");
        
        // Computed pour déterminer si on doit afficher le champ transactionId
        const showTransactionIdField = computed(() => {
            return mode.value !== null && mode.value !== undefined && mode.value !== 0 && mode.value !== 1 && mode.value !== 2;
        });

        var check = reactive({
            typeError: "RAS",
            idTransaction: 0,
        });

        const reupererContrat = async (recherche) => {
            try {
                const response = await ApiService.post("listeContrat", { recherche });
                if (response.data) {
                    return (contrats.value = response.data.data.map((el) => {
                        return {
                            value: el.id,
                            label:
                                el.ref + " - Lo : " + el.locataire + " - Ex : " + el.exploitant,
                        };
                    }));
                }
            } catch (err) {
                if (axios.isAxiosError(err) && err.response) {
                    error(err.response.data.message || err.message);
                } else {
                    if (err instanceof Error) {
                        error(err.message);
                    } else {
                        error(String(err));
                    }
                }
            }
        };

        const reupererMode = async () => {
            try {
                const response = await ApiService.get("listeMode");
                if (response.data) {
                    return (modes.value = response.data.data.map((el) => {
                        return {
                            value: el.id,
                            label: el.libelle,
                        };
                    }));
                }
            } catch (err) {
                if (axios.isAxiosError(err) && err.response) {
                    error(err.response.data.message || err.message);
                } else {
                    if (err instanceof Error) {
                        error(err.message);
                    } else {
                        error(String(err));
                    }
                }
            }
        };
        const typeOptions = ref([]);
        const reupererListeType = async () => {
            try {
                const response = await axios.get("recettes/type");
                if (response.data) {
                    return (typeOptions.value = response.data.data.map((el) => {
                        return {
                            value: el.id,
                            label: el.libelle,
                        };
                    }));
                }
            } catch (err) {
                if (axios.isAxiosError(err) && err.response) {
                    error(err.response.data.message || err.message);
                } else {
                    if (err instanceof Error) {
                        error(err.message);
                    } else {
                        error(String(err));
                    }
                }
            }
        };
        const periodiciteOptions = [
            { value: "Unité", label: "Unité" },
            { value: "Panier", label: "Panier" },
            { value: "Killogramme", label: "Killogramme" },
            { value: "Litre", label: "Litre" },
            { value: "Kilomètre", label: "Kilomètre" },
            { value: "Heure", label: "Heure" },
            { value: "Jour", label: "Jour" },
            { value: "Semaine", label: "Semaine" },
            { value: "Mois", label: "Mois" },
            { value: "Trimestre", label: "Trimestre" },
            { value: "Semestre", label: "Semestre" },
            { value: "An", label: "An" }
        ];
        const intitule = ref("");
        const frequence = ref("Mois");
        const duree = ref(0);

        const dateActuelle = ref((format(new Date(), "yyy-MM-dd") || ""));

        const claculMontant = async () => {
            if (taux.value && duree.value) {
                const montantTotal = (taux.value * duree.value);
                montant.value = montantTotal;
            } else {
                montant.value = 0;
            }
        }
        const openAndPrint = (url: string) => {
            const newWindow = window.open(url, "_blank");

            if (newWindow) {
                newWindow.onload = () => {
                    newWindow.print();
                };
            } else {
                console.error("Impossible d'ouvrir la fenêtre");
            }
        };
        function openNewWindow(data: any) {
            openAndPrint(getUrlApiForFiles("Recu", data.refPaiement + ".pdf"));
        }

        const soumettre = async (values, { resetForm }) => {
            valideEtape1.value = false;
            try {
                const response = await axios.post("paiement/autre/recette", values);
                if (response.status == 200) {
                    success("Paiement effectué avec succès");
                    resetForm();
                    router.push({ name: "ListePaiementAutreRecettePage" });
                    const maFonction = async () => {
                        const result = await Swal.fire({
                            html: `<div>Cliquer sur le bouton Aperçu ci-dessous pour avoir un aperçu de votre document</div>`,
                            icon: "success",
                            buttonsStyling: true,
                            confirmButtonText: "Aperçu",
                            showCancelButton: false,
                            cancelButtonText: `Fermer`,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            heightAuto: false,
                            customClass: {
                                confirmButton: "btn btn-success",
                                cancelButton: "btn btn-warning",
                            },
                        });

                        if (result.isConfirmed) {
                            openNewWindow(response.data.paiement);
                        }
                    };
                    // Utiliser setTimeout pour exécuter la fonction après la durée spécifiée
                    await setTimeout(maFonction, 3000);
                }
            } catch (err) {
                if (axios.isAxiosError(err) && err.response) {
                    error(err.response.data.message || err.message);
                } else {
                    if (err instanceof Error) {
                        error(err.message);
                    } else {
                        error(String(err));
                    }
                }
            } finally {
                valideEtape1.value = true;
            }

        };
        async function successHandler(response, values, { resetForm }) {
            // Mise à jour de l'objet check avec les informations de la réponse de succès
            check.typeError = "SUCCESS";
            check.idTransaction = response.transactionId;
            values["mode"] = 2;
            values["idTransaction"] = check.idTransaction;
            values["check"] = check;
            // Bloc de code à exécuter lorsque le paiement est un succès
            if (check.typeError === "SUCCESS") {
                // Appel de la fonction addAbonnement et attente de son exécution
                await soumettre(values, { resetForm });
                valideEtape1.value = true;
            } else {
                check.typeError = "ECHOUE";
                check.idTransaction = 0;
            }

            // Retourne les données après l'exécution
            return { check, response };
        }

        async function failHandler(response, values, { resetForm }) {
            // Mise à jour de l'objet check avec les informations de l'échec
            check.typeError = "ECHOUE";
            check.idTransaction = response.transactionId;

            values["check"] = check;
            if (check.typeError === "ECHOUE") {
                // Appel de la fonction addAbonnement et attente de son exécution
                //await soumettre(values, { resetForm });
                valideEtape1.value = true;
            }

            // Retourne les données après l'exécution
            return { check, response };
        }

        const payer = async (values, { resetForm }) => {
            console.log("PAYER ==> ", values);
            valideEtape1.value = false;
            if (values.mode == 1) {
                values.mode = 1;
                try {
                    const result = await Swal.fire({
                        text:
                            "Vous êtes sur le point de faire un paiement d'une somme de " +
                            values.montant +
                            " F CFA",
                        icon: "warning",
                        buttonsStyling: true,
                        showCancelButton: true,
                        confirmButtonText: "Payer",
                        cancelButtonText: `Annuler`,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        heightAuto: false,
                        customClass: {
                            confirmButton: "btn btn-danger",
                        },
                    });

                    if (result.isConfirmed) {
                        values["check"] = KKIAPAY.check;
                        await soumettre(values, { resetForm });
                    } else {
                        valideEtape1.value = true;
                    }
                } catch (err) {
                    if (axios.isAxiosError(err) && err.response) {
                        error(err.response.data.message || err.message);
                    } else {
                        if (err instanceof Error) {
                            error(err.message);
                        } else {
                            error(String(err));
                        }
                    }
                    valideEtape1.value = true;
                }
                resetForm();
                return;
            }

            if (values.mode == 2) {
                values.mode = 2;
                try {
                    const result = await Swal.fire({
                        text:
                            "Vous êtes sur le point de faire un paiement d'une somme de " +
                            values.montant +
                            " F CFA",
                        icon: "warning",
                        buttonsStyling: true,
                        showCancelButton: true,
                        confirmButtonText: "Payer",
                        cancelButtonText: `Annuler`,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        heightAuto: false,
                        customClass: {
                            confirmButton: "btn btn-danger",
                        },
                    });

                    if (result.isConfirmed) {
                        KKIAPAY.kkia(values.montant);
                        await new Promise<void>((resolve) => {
                            addKkiapayListener("failed", (event) => {
                                failHandler(event, values, { resetForm });
                                resolve();
                            });

                            addKkiapayListener("success", (event) => {
                                successHandler(event, values, { resetForm });
                                resolve();
                            });

                            const checkRef = toRef(check);

                            let resolved = false;

                            const intervalId = setInterval(() => {
                                if (!resolved && checkRef.value.typeError !== "ECHOUE") {
                                    clearInterval(intervalId);
                                    resolved = true;
                                    resolve();
                                }
                            }, 500);
                        });
                    } else {
                        valideEtape1.value = true;
                    }
                } catch (error) {
                    valideEtape1.value = true;
                }
                return;
            }

            // Gestion des modes différents de 1 et 2
            if (values.mode !== 1 && values.mode !== 2 && values.mode > 2) {
                try {
                    // Vérifier que transactionId est présent
                    if (!values.transactionId || values.transactionId.trim() === "") {
                        error("La référence externe est obligatoire");
                        valideEtape1.value = true;
                        return;
                    }

                    // Avant soumission, configurer check
                    check.typeError = "SUCCESS";
                    check.idTransaction = values.transactionId;
                    values["idTransaction"] = check.idTransaction;
                    values["check"] = check;

                    const result = await Swal.fire({
                        text:
                            "Vous êtes sur le point de faire un paiement d'une somme de " +
                            values.montant +
                            " F CFA",
                        icon: "warning",
                        buttonsStyling: true,
                        showCancelButton: true,
                        confirmButtonText: "Payer",
                        cancelButtonText: `Annuler`,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        heightAuto: false,
                        customClass: {
                            confirmButton: "btn btn-danger",
                        },
                    });

                    if (result.isConfirmed) {
                        await soumettre(values, { resetForm });
                    } else {
                        valideEtape1.value = true;
                    }
                } catch (err) {
                    if (axios.isAxiosError(err) && err.response) {
                        error(err.response.data.message || err.message);
                    } else {
                        if (err instanceof Error) {
                            error(err.message);
                        } else {
                            error(String(err));
                        }
                    }
                    valideEtape1.value = true;
                }
                return;
            }
            
            // Si aucun mode ne correspond, réinitialiser le bouton
            valideEtape1.value = true;
        };
        onMounted(async () => {
            await reupererMode();
            await reupererListeType();
        });

        watch([taux, duree], async () => {
            await claculMontant();
        });

        return {
            reupererContrat,
            typeOptions,
            contrats,
            contrat,
            taux,
            duree,
            frequence,
            intitule,
            usager,
            paiementSchema,
            valideEtape1,
            mode,
            modes,
            agent,
            payer,
            typeRecette,
            soumettre,
            montant,
            dateDebut,
            periodiciteOptions,
            dateActuelle,
            transactionId,
            showTransactionIdField,
        };
    }
});
</script>
<style>
.clickable-row {
    cursor: pointer;
}

.clickable-row:hover {
    background-color: #bf6b6b;
}

.selected-row {
    border: 2px solid green;
    color: #fff;
    background-color: #0f4030;
    /* Couleur de fond vert clair */
}
</style>